import { colors, fonts, screen } from 'components/styles/variables';

function LinkButton({
  onClick,
  className = '',
  children,
}: {
  onClick: () => void;
  children: string;
  className?: string;
}): JSX.Element {
  return (
    <button className={`shared-link-button ${className}`} onClick={onClick}>
      {children}
      <style jsx>{`
        .shared-link-button {
          padding: 0;
          font-family: ${fonts.default};
          background-color: transparent;
          font-weight: 400;
          color: ${colors.ALR1};
          border: none;
          font-size: 14px;
          cursor: pointer;
          border-bottom: 1px solid ${colors.WHITE};
        }

        .link-button {
          align-self: flex-start;
          white-space: nowrap;
        }

        @media (min-width: ${screen.smMin}) {
          .shared-link-button {
            font-size: 16px;
          }
        }

        .shared-link-button:hover {
          border-bottom: 1px solid ${colors.ALR1};
        }
      `}</style>
    </button>
  );
}

export default LinkButton;
